<template>
    <div 
        class="modal fade"
        id="addUserModal"
        tabindex="-1"
        aria-labelledby="addUser"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addUser">
                        {{isEdit ? 'Edit' : 'Add'}} User
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <form @submit.prevent="submit">
                <div class="modal-body">
                    <div class="col-md-12 text-start">
                        <label for="name" class="form-label">Name:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.name ? true : false}" id="name" v-model="form.name" autofocus aria-describedby="nameFeedback" required>
                            <div v-if="errors.name" id="nameFeedback" class="invalid-feedback">
                                {{errors.name}}
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 text-start mt-2">
                        <label for="email" class="form-label">Email:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.email ? true : false}" id="email" v-model="form.email" autofocus aria-describedby="emailFeedback" required>
                            <div v-if="errors.email" id="emailFeedback" class="invalid-feedback">
                                {{errors.email}}
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 text-start mt-2">
                        <label for="password" class="form-label">Password:</label>
                        <div class="input-group has-validation">
                            <input type="password" :class="{'form-control':true, 'is-invalid':errors.password ? true : false}" id="password" v-model="form.password" autofocus aria-describedby="passwordFeedback" :required="!isEdit" >
                            <div v-if="errors.password" id="passwordFeedback" class="invalid-feedback">
                                {{errors.password}}
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 text-start mt-2">
                        <label for="password_confirmation" class="form-label">Confirm Password:</label>
                        <div class="input-group has-validation">
                            <input type="password" :class="{'form-control':true, 'is-invalid':errors.password_confirmation ? true : false}" id="password_confirmation" v-model="form.password_confirmation" autofocus aria-describedby="passwordFeedback" :required="!isEdit">
                            <div v-if="errors.password_confirmation" id="passwordFeedback" class="invalid-feedback">
                                {{errors.password_confirmation}}
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 text-start mt-2">
                        <file-pond
                            name="imageFilepond"
                            ref="pond"
                            v-bind:allow-multiple="true"
                            accept-file-types="image/png, image/jpeg, image/svg"
                            v-bind:server="{
                                url: '',
                                timeout: 700,
                                process: {
                                    url: '/upload-profile-img',
                                    headers: {
                                        'X-CSRF-TOKEN': csrf
                                    },
                                    method: 'POST',
                                    withCredentials: false,
                                    onload: handleFilePondLoad,
                                    onerror: () => {}
                                },
                                remove: handleFilePondRemove,
                                revert: handleFilePondRevert                           
                            }"
                            v-bind:files="myFiles"
                            v-on:init="handleFilePondInit"
                        >
                        </file-pond>
                    </div>


                    

                    <div class="col-md-12 text-start mt-2">
                        <label for="user_type_id" class="form-label">Role:</label>
                        <div class="input-group has-validation">
                            <select :class="{'form-select':true, 'is-invalid':errors.user_id ? true : false}" id="user_type_id" v-model="form.user_type_id" required autofocus aria-describedby="user_type_idFeedback">
                                <option v-for="type in user_types" :key="type.id" :value="type.id">{{ type.name }}</option>
                            </select>
                            <div  v-if="errors.user_type_id" id="user_type_idFeedback" class="invalid-feedback">
                                {{errors.user_type_id}}
                            </div>
                        </div>
                    </div>  
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        Cancel
                    </button>
                    <button type="submit" class="btn btn-primary" :disabled="form.processing">
                        {{isEdit ? 'Update' : 'Save'}}
                    </button>
                </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap';
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

// Import the plugin code
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';

// Import the plugin styles
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview,
    FilePondPluginFilePoster
);

import axios from 'axios';

export default {
    props: {
        user: Object,
        user_types: Array,
        isEdit: Boolean
    },
    components: {
        FilePond
    },
    data() {
        return {
            modal: null,
            form: this.$inertia.form({
                name: this.user ? this.user.name : "" ,
                image: this.user ? this.user.image : "" ,
                email: this.user ? this.user.email : "",
                password: this.user ? this.user.password : "" ,
                user_type_id: this.user ? this.user.user_type_id : "",
                password_confirmation: this.user ? this.user.password_confirmation : "" ,
            }),
            errors: {
               name: null,
               email: null,
               image: null,
               password: null,
               user_type_id: null 
            },
            csrf: '',
            myFiles: []
        };
    },
    mounted() {
        var modalEl = document.getElementById('addUserModal')
        this.modal = new Modal(modalEl)
        this.modal.show();

        this.csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

        modalEl.addEventListener('hidden.bs.modal',  (event) => {
            this.$emit('modelStatusChanged',false)
        })
    },
    methods: {
        close(){
            //this.isOpen = false
        },
        handleFilePondInit() {
            if(this.form.image) {
                this.myFiles = [{
                    source: '/' + this.form.image,
                    options: {
                        type: 'local',
                        metadata: {
                            poster: '/' + this.form.image,
                        }
                    }
                }]
            } else {
                this.myFiles = []
            }
        },
        handleFilePondLoad(response) {
            this.form.image = response
        },
        handleFilePondRemove (source, load, error) {
            this.form.image = ''
            load();
        },
        handleFilePondRevert (unique, load, error) {
            axios.post('/upload-profile-revert', {
                image: this.form.image
            })
            load();
        },
        submit() {
            let route = this.isEdit ? this.route("users.update",this.user.id) : this.route("users.store")
            let method = this.isEdit ? 'patch' : 'post'
            this.form[this.isEdit ?'patch' : 'post'](route, {
                onError: (errors) => {
                    console.log(errors)
                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        if (errors.hasOwnProperty("password")) {
                            toast.message = errors.password;
                            this.errors.password = errors.password;
                        }

                        if (errors.hasOwnProperty("email")) {
                            toast.message = errors.email;
                            this.errors.email = errors.email;
                        }

                        if (errors.hasOwnProperty("name")) {
                            toast.message = errors.name;
                            this.errors.name = errors.name;
                        }
                    }
                }, 
                onSuccess: () => {
                    this.form.reset();
                    this.modal.hide();

                }
            });
        },
    },
};
</script>
